/**

 * Essential haircare — tabs + product fill (before Slick) + Halo slider.

 * Products render server-side from collections; missing handles load once via AJAX

 * before the slider initializes (no unslick / rebuild after init).

 */

(function () {

  var PANELS = [

    'col-dede', 'col-nounou', 'col-smoothing', 'col-curl', 'col-volu',

    'col-solu', 'col-momo', 'col-melu', 'col-minu'

  ];

  var TRANSITION_MS = 400;

  var MOBILE_NAV_BREAKPOINT = 798;

  var navCarouselSyncing = false;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;



  function getSliderFn() {

    if (window.sharedFunctions && window.sharedFunctions.productBlockSilder) {

      return window.sharedFunctions.productBlockSilder;

    }

    if (window.halo && window.halo.productBlockSilder) {

      return window.halo.productBlockSilder;

    }

    return null;

  }



  function whenReady(cb, maxTries) {

    var tries = 0;

    var limit = maxTries || 150;

    (function tick() {

      if (window.jQuery && window.jQuery.fn.slick && getSliderFn()) {

        cb();

        return;

      }

      tries += 1;

      if (tries < limit) setTimeout(tick, 40);

    })();

  }



  function syncNavSpacer() {
    var nav = document.getElementById('essentialmenu');
    var spacer = document.getElementById('davines-nav-spacer');
    if (!nav || !spacer) return;
    var h = nav.offsetHeight;
    if (h > 0) spacer.style.minHeight = h + 'px';
  }

  function portalNavToBody() {
    var nav = document.getElementById('essentialmenu');
    if (!nav || nav.getAttribute('data-davines-portaled') === '1') return;
    document.body.appendChild(nav);
    nav.setAttribute('data-davines-portaled', '1');
    nav.classList.add('davines-nav-portaled');
    syncNavSpacer();
  }

  function updateNavTop() {
    var nav = document.getElementById('essentialmenu');
    if (!nav) return;
    var topPx = 120;
    var header =
      document.querySelector('.shopify-section-header-sticky') ||
      document.getElementById('shopify-section-header') ||
      document.querySelector('.header-wrapper');
    if (header) {
      var rect = header.getBoundingClientRect();
      if (rect.height > 0) {
        topPx = Math.ceil(rect.bottom);
      }
    }
    var ann = document.querySelector('.announcement-bar, #shopify-section-announcement-bar');
    if (ann) {
      var annRect = ann.getBoundingClientRect();
      if (annRect.height > 0 && annRect.bottom > 0) {
        topPx = Math.max(topPx, Math.ceil(annRect.bottom));
      }
    }
    nav.style.setProperty('--davines-nav-top', topPx + 'px');
    document.documentElement.style.setProperty('--davines-nav-top', topPx + 'px');
  }

  function updateNavSticky() {
    var nav = document.getElementById('essentialmenu');
    if (!nav) return;
    updateNavTop();
    if (window.scrollY > 150) {
      nav.classList.add('active');
    } else {
      nav.classList.remove('active');
    }
  }

  function getProductLinesScrollOffset() {
    updateNavTop();
    syncNavSpacer();
    var nav = document.getElementById('essentialmenu');
    if (nav) {
      var navPos = getComputedStyle(nav).position;
      var navRect = nav.getBoundingClientRect();
      /* rect.bottom je upotrebljiv samo dok nav lebdi preko sadrzaja;
         u normalnom toku dokumenta to je pozicija duboko u stranici */
      if ((navPos === 'fixed' || navPos === 'sticky') && navRect.height > 0 && navRect.bottom > 0) {
        return Math.round(navRect.bottom) + 16;
      }
    }
    var topPx = 120;
    var cssVar = getComputedStyle(document.documentElement).getPropertyValue('--davines-nav-top');
    if (cssVar) {
      var parsed = parseInt(cssVar, 10);
      if (!isNaN(parsed) && parsed > 0) topPx = parsed;
    }
    var navH = nav && nav.offsetHeight ? nav.offsetHeight : 0;
    return topPx + navH + 16;
  }

  function getProductLinesScrollAnchor(panelId) {
    var panel = panelId ? document.getElementById(panelId) : null;
    if (!panel || !panel.classList.contains('is-active')) {
      panel = document.querySelector('.davines-line-panel.is-active');
    }
    if (panel) {
      return (
        panel.querySelector('.halo-block-header') ||
        panel.querySelector('.products-carousel') ||
        panel.querySelector('.halo-block-content') ||
        panel.querySelector('.halo-product-block') ||
        panel
      );
    }
    var panelsWrap = document.querySelector('.davines-line-panels');
    if (panelsWrap) return panelsWrap;
    return (
      document.getElementById('davines-nav-spacer') ||
      document.querySelector('.sections-davines-product-families')
    );
  }

  function scrollToProductLines(panelId) {
    var nav = document.getElementById('essentialmenu');
    if (nav) nav.classList.add('active');

    var cancelled = false;
    var ourTargetY = null;
    var guardActive = false;

    function releaseToUser() { cancelled = true; }
    window.addEventListener('wheel', releaseToUser, { passive: true, once: true });
    window.addEventListener('keydown', releaseToUser, { once: true });
    window.addEventListener('scroll', function () {
      if (!guardActive || cancelled || ourTargetY === null) return;
      if (Math.abs(window.scrollY - ourTargetY) > 140) cancelled = true;
    }, { passive: true });

    function computeTargetY() {
      var anchor = getProductLinesScrollAnchor(panelId);
      if (!anchor) return null;
      var offset = getProductLinesScrollOffset();
      var absTop = window.scrollY + anchor.getBoundingClientRect().top;
      /* Ako je izmereni offset veci od same pozicije sekcije, merenje je
         promaseno (npr. nav uhvacen dok nije bio fiksiran). Bez ovoga bi
         target ispao negativan, Math.max ga svede na 0 i korisnik zavrsi
         na vrhu stranice. Radije ne diramo skrol. */
      if (offset > absTop) return null;
      return Math.max(0, Math.round(absTop - offset));
    }

    function settle(animated) {
      if (cancelled) return;
      var y = computeTargetY();
      if (y === null) return;
      ourTargetY = y;
      if (Math.abs(window.scrollY - y) <= 2) return;
      window.scrollTo({
        top: y,
        behavior: animated && !prefersReducedMotion ? 'smooth' : 'auto'
      });
    }

    settle(true);

    /* cuvara pustamo tek kad se prvi (moguce animirani) skrol smiri,
       da nas sopstvena animacija ne prekine */
    window.setTimeout(function () { guardActive = true; }, 1200);

    if (panelId) {
      var panel = document.getElementById(panelId);
      if (panel) scheduleSliderInit(panel);
    }

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        window.requestAnimationFrame(function () { settle(false); });
      });
      /* body hvata i sadrzaj IZNAD sekcije: kad se slika ili app ucita
         kasno, stranica poraste i sekcija se odgura nadole */
      if (document.body) ro.observe(document.body);
      var watched = panelId ? document.getElementById(panelId) : null;
      if (watched) ro.observe(watched);
      if (nav) ro.observe(nav);
      window.setTimeout(function () { ro.disconnect(); }, 15000);
    }

    window.addEventListener('load', function () { settle(false); }, { once: true });

    [120, 300, 550, 900, 1400, 2100, 3000, 4000, 5200, 6500, 8000, 10000, 12500, 15000].forEach(function (ms) {
      window.setTimeout(function () {
        if (cancelled) return;
        settle(false);
        updateNavSticky();
        if (nav) nav.classList.add('active');
      }, ms);
    });
  }

  function getPanelIdFromNavLink(link) {

    if (!link) return '';

    return link.getAttribute('data-davines-panel') ||

      (link.getAttribute('href') || '').replace('#', '');

  }



  function isMobileCategoryNav() {

    return window.innerWidth <= MOBILE_NAV_BREAKPOINT;

  }



  function getNavSlideIndex(panelId) {

    var nav = document.getElementById('essentialmenu');

    if (!nav || !panelId) return -1;

    var links = nav.querySelectorAll('a[data-davines-panel], a[href^="#col-"]');

    for (var i = 0; i < links.length; i++) {

      if (getPanelIdFromNavLink(links[i]) === panelId) return i;

    }

    return -1;

  }



  function syncNavCarouselToPanel(panelId) {

    if (navCarouselSyncing || !isMobileCategoryNav() || !window.jQuery) return;

    var nav = document.getElementById('essentialmenu');

    if (!nav) return;

    var $carousel = window.jQuery(nav).find('.slick-carousel');

    if (!$carousel.length || !$carousel.hasClass('slick-initialized')) return;

    var idx = getNavSlideIndex(panelId);

    if (idx < 0) return;

    navCarouselSyncing = true;

    try {

      $carousel.slick('slickGoTo', idx);

    } catch (e) { /* ignore */ }

    navCarouselSyncing = false;

  }



  function initCategoryNavCarousel() {

    whenReady(function () {

      var nav = document.getElementById('essentialmenu');

      if (!nav || !window.jQuery || !window.jQuery.fn.slick) return;

      var $carousel = window.jQuery(nav).find('.slick-carousel');

      if (!$carousel.length) return;

      if ($carousel.hasClass('slick-initialized')) {

        try { $carousel.slick('unslick'); } catch (e) { /* ignore */ }

      }

      if (!isMobileCategoryNav()) return;

      $carousel.slick({

        mobileFirst: true,

        slidesToShow: 1,

        slidesToScroll: 1,

        autoplay: false,

        infinite: false,

        arrows: true,

        prevArrow: "<button type='button' class='slick-prev pull-left' aria-label='Previous category'><i class='fa fa-long-arrow-left' aria-hidden='true'></i></button>",

        nextArrow: "<button type='button' class='slick-next pull-right' aria-label='Next category'><i class='fa fa-long-arrow-right' aria-hidden='true'></i></button>",

        responsive: [{

          breakpoint: MOBILE_NAV_BREAKPOINT + 1,

          settings: 'unslick'

        }]

      });

      $carousel.off('afterChange.davinesNav').on('afterChange.davinesNav', function (event, slick, currentSlide) {

        if (navCarouselSyncing) return;

        var slide = slick.$slides.eq(currentSlide);

        var link = slide.find('a[data-davines-panel], a[href^="#col-"]').get(0);

        if (!link) return;

        var panelId = getPanelIdFromNavLink(link);

        if (!panelId || PANELS.indexOf(panelId) === -1) return;

        navCarouselSyncing = true;

        activatePanel(panelId, true);

        navCarouselSyncing = false;

      });

    });

  }



  function bindNavSticky() {
    portalNavToBody();
    var ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateNavSticky();
        syncNavSpacer();
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    updateNavSticky();
    window.setTimeout(syncNavSpacer, 300);
  }



  function getPanelsWrap() {

    return document.querySelector('.davines-line-panels');

  }



  function updatePanelHeight(panel) {

    var wrap = getPanelsWrap();

    if (!wrap || !panel) return;

    if (panel.classList.contains('is-active')) {

      wrap.style.minHeight = '';

      return;

    }

    wrap.style.minHeight = panel.scrollHeight + 'px';

  }



  function updateNav(activeId) {

    document.querySelectorAll('#essentialmenu a[data-davines-panel], #essentialmenu a[href^="#col-"]').forEach(function (a) {

      var pid = getPanelIdFromNavLink(a);

      a.classList.toggle('selected', pid === activeId);

    });

    syncNavCarouselToPanel(activeId);

    updateNavSticky();

  }



  function getExpectedHandles(block) {

    var raw = block.getAttribute('data-product-handles') || '';

    return raw.split('|').map(function (h) { return h.trim(); }).filter(Boolean);

  }



  function sortHandlesByPreference(collectionHandles, preferredOrder) {

    var seen = {};

    var out = [];

    preferredOrder.forEach(function (h) {

      if (h && collectionHandles.indexOf(h) !== -1 && !seen[h]) {

        seen[h] = true;

        out.push(h);

      }

    });

    collectionHandles.forEach(function (h) {

      if (h && !seen[h]) {

        seen[h] = true;

        out.push(h);

      }

    });

    return out;

  }



  function mergeListedOrphans(collectionHandles, listed) {

    var seen = {};

    var out = collectionHandles.slice();

    collectionHandles.forEach(function (h) { seen[h] = true; });

    listed.forEach(function (h) {

      if (h && !seen[h]) {

        seen[h] = true;

        out.push(h);

      }

    });

    return out;

  }



  function fetchCollectionHandles(collectionHandle, root) {

    if (!collectionHandle) return Promise.resolve([]);

    return fetch(root + '/collections/' + encodeURIComponent(collectionHandle) + '/products.json?limit=250')

      .then(function (res) {

        if (!res.ok) return [];

        return res.json();

      })

      .then(function (data) {

        var products = data && data.products ? data.products : [];

        return products.map(function (p) { return p.handle; }).filter(Boolean);

      })

      .catch(function () { return []; });

  }



  function getPanelHandles(block, root) {

    var listed = getExpectedHandles(block);

    var collectionHandle = block.getAttribute('data-collection') || '';

    if (!collectionHandle) return Promise.resolve(listed);

    return fetchCollectionHandles(collectionHandle, root).then(function (colHandles) {

      if (!colHandles.length) return listed;

      var ordered = sortHandlesByPreference(colHandles, listed);

      return mergeListedOrphans(ordered, listed);

    });

  }



  function getHandleFromProductEl(el) {

    if (!el) return null;

    var byAttr = el.getAttribute('data-davines-handle');

    if (byAttr) return byAttr;

    var q = el.querySelector('[data-product-handle]');

    if (q) return q.getAttribute('data-product-handle');

    var a = el.querySelector('a[href*="/products/"]');

    if (a) {

      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);

      if (m) return m[1];

    }

    return null;

  }



  function getRenderedHandles(carousel) {

    var handles = [];

    if (!carousel) return handles;

    carousel.querySelectorAll('.product').forEach(function (el) {

      var h = getHandleFromProductEl(el);

      if (h && handles.indexOf(h) === -1) handles.push(h);

    });

    return handles;

  }



  function getExistingProductHtml(carousel, handle) {

    var products = carousel.querySelectorAll('.product');

    for (var i = 0; i < products.length; i++) {

      if (getHandleFromProductEl(products[i]) === handle) {

        return products[i].outerHTML;

      }

    }

    return '';

  }



  function fetchProductCard(handle, root, sectionId) {

    return fetch(root + '/products/' + encodeURIComponent(handle) + '?view=ajax_davines_line_item')

      .then(function (res) {

        if (!res.ok) return '';

        return res.text();

      })

      .then(function (html) {

        if (!html) return '';

        if (!sectionId) return html;

        return html

          .replace(/sectionId=&quot;&quot;/g, 'sectionId=&quot;' + sectionId + '&quot;')

          .replace(/sectionId=""/g, 'sectionId="' + sectionId + '"');

      })

      .catch(function () { return ''; });

  }



  function handlesAllPresent(handles, rendered) {

    if (!handles.length) return true;

    for (var i = 0; i < handles.length; i++) {

      if (rendered.indexOf(handles[i]) === -1) return false;

    }

    return true;

  }



  function destroySlider(panel) {

    if (!window.jQuery) return;

    var $carousel = window.jQuery(panel).find('.products-carousel');

    if ($carousel.length && $carousel.hasClass('slick-initialized')) {

      try {

        $carousel.slick('unslick');

      } catch (e) { /* ignore */ }

    }

  }



  function ensurePanelProducts(panel) {

    var block = panel.querySelector('[data-product-block]');

    var carousel = panel.querySelector('.products-carousel');

    if (!block || !carousel) {

      panel.setAttribute('data-davines-products-ready', '1');

      return Promise.resolve();

    }



    var sectionId = block.getAttribute('sectionId') || '';

    var root = (window.routes && window.routes.root) || '';

    var collectionHandle = block.getAttribute('data-collection') || '';

    var syncKey = collectionHandle || 'handles-only';



    return getPanelHandles(block, root).then(function (handles) {

      if (!handles.length) {

        carousel.innerHTML = '';

        panel.setAttribute('data-davines-products-ready', '1');

        panel.setAttribute('data-davines-sync-key', syncKey + ':0');

        return;

      }



      var rendered = getRenderedHandles(carousel);

      var prevKey = panel.getAttribute('data-davines-sync-key') || '';

      var nextKey = syncKey + ':' + handles.join(',');

      var needsSync =

        prevKey !== nextKey ||

        !handlesAllPresent(handles, rendered);



      if (

        panel.getAttribute('data-davines-products-ready') === '1' &&

        !needsSync

      ) {

        return;

      }



      panel.setAttribute('data-davines-loading', '1');

      panel.removeAttribute('data-davines-products-ready');



      if (carousel.classList.contains('slick-initialized')) {

        destroySlider(panel);

      }



      return Promise.all(handles.map(function (handle) {

        var existing = getExistingProductHtml(carousel, handle);

        if (existing) return Promise.resolve(existing);

        return fetchProductCard(handle, root, sectionId);

      }))

        .then(function (chunks) {

          var html = chunks.filter(Boolean).join('');

          if (html) {

            carousel.innerHTML = html;

          }

          var renderedAfter = getRenderedHandles(carousel);

          if (handlesAllPresent(handles, renderedAfter)) {

            panel.setAttribute('data-davines-products-ready', '1');

            panel.setAttribute('data-davines-sync-key', nextKey);

          } else {

            panel.removeAttribute('data-davines-products-ready');

            panel.removeAttribute('data-davines-sync-key');

          }

          panel.removeAttribute('data-davines-loading');

          if (window.wishlist && window.wishlist.show && window.halo && window.halo.setLocalStorageProductForWishlist) {

            window.halo.setLocalStorageProductForWishlist();

          }

          if (window.davinesFixQuickShop) {

            window.davinesFixQuickShop(panel);

          }

        });

    }).catch(function () {

      panel.removeAttribute('data-davines-loading');

      panel.removeAttribute('data-davines-products-ready');

    });

  }



  function initSliderWithRetry(panel, attempt) {

    var n = attempt || 0;

    if (initSlider(panel)) return;

    if (n < 40) {

      window.setTimeout(function () {

        initSliderWithRetry(panel, n + 1);

      }, 100 + n * 50);

    }

  }



  function initSlider(panel) {

    if (!window.jQuery) return false;

    var $ = window.jQuery;

    var $block = $(panel).find('[data-product-block]');

    if (!$block.length) return false;

    var $carousel = $block.find('.products-carousel');

    if (!$carousel.length || !$carousel.children('.product').length) return false;



    if ($carousel.hasClass('slick-initialized')) {

      try {

        $carousel.slick('setPosition');

      } catch (e) { /* ignore */ }

      updatePanelHeight(panel);

      return true;

    }



    var sliderFn = getSliderFn();

    if (sliderFn) {

      sliderFn($block);

    }



    if (!$carousel.hasClass('slick-initialized')) {

      return false;

    }



    try {

      $carousel.slick('setPosition');

    } catch (e) { /* ignore */ }



    if (window.lazySizes && window.lazySizes.loader) {

      panel.querySelectorAll('.lazyload').forEach(function (img) {

        window.lazySizes.loader.unveil(img);

      });

    }



    updatePanelHeight(panel);

    if (window.davinesFixQuickShop) {

      window.davinesFixQuickShop(panel);

    }

    return true;

  }



  function setPanelDisplay(activeId, skipAnimation) {

    var wrap = getPanelsWrap();

    var current = wrap && wrap.querySelector('.davines-line-panel.is-active');

    var next = document.getElementById(activeId);

    if (!next) return;



    function applyState() {

      PANELS.forEach(function (id) {

        var el = document.getElementById(id);

        if (!el) return;

        el.classList.remove('is-active', 'is-leaving');

        el.setAttribute('aria-hidden', id === activeId ? 'false' : 'true');

        if (id === activeId) el.classList.add('is-active');

      });

      updateNav(activeId);

      requestAnimationFrame(function () {

        updatePanelHeight(next);

      });

    }



    if (skipAnimation || prefersReducedMotion || !current || current === next) {

      applyState();

      return;

    }



    current.classList.add('is-leaving');

    current.classList.remove('is-active');

    current.setAttribute('aria-hidden', 'true');



    next.classList.add('is-active');

    next.setAttribute('aria-hidden', 'false');

    updateNav(activeId);



    requestAnimationFrame(function () {

      updatePanelHeight(next);

    });



    window.setTimeout(function () {

      current.classList.remove('is-leaving');

    }, TRANSITION_MS);

  }



  function scheduleSliderInit(panel) {
    if (!panel) return;
    whenReady(function () {
      requestAnimationFrame(function () {
        initSliderWithRetry(panel, 0);
      });
      [200, 500, 1000, 2000, 3500].forEach(function (ms) {
        window.setTimeout(function () {
          var carousel = panel.querySelector('.products-carousel');
          if (carousel && !carousel.classList.contains('slick-initialized')) {
            initSliderWithRetry(panel, 0);
          } else if (carousel) {
            try {
              window.jQuery(carousel).slick('setPosition');
            } catch (e) { /* ignore */ }
          }
        }, ms);
      });
    });
  }

  /* --- Deep-link preko URL hash-a: #dede, #nounou, #smoothing ... --- */

  function panelIdToHash(panelId) {

    return panelId ? String(panelId).replace(/^col-/, '') : '';

  }

  function hashToPanelId(rawHash) {

    var raw = String(rawHash || '').replace(/^#/, '').trim().toLowerCase();

    if (!raw) return '';

    var candidate = raw.indexOf('col-') === 0 ? raw : 'col-' + raw;

    return PANELS.indexOf(candidate) !== -1 ? candidate : '';

  }

  function writePanelHash(panelId) {
    var hash = panelIdToHash(panelId);
    if (!hash) return;
    var next = '#' + hash;
    if (window.location.hash === next) return;
    /* Namerno nema fallbacka na window.location.hash = next: nijedan element
       nema id "dede", pa bi browser na to odgovorio skokom na vrh stranice.
       Ako replaceState zakaze (Chrome ga gusi posle ~100 poziva u 10s),
       radije preskacemo upis hash-a nego da bacimo korisnika na vrh. */
    try {
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search + next);
      }
    } catch (e) { /* hash ostaje nepromenjen */ }
  }

  function bindHashNavigation() {
    window.addEventListener('hashchange', function () {
      var panelId = hashToPanelId(window.location.hash);
      if (!panelId) return;
      activatePanel(panelId);
      scrollToProductLines(panelId);
    });
  }

  function activatePanel(activeId, skipAnimation, skipHash) {

    if (!activeId || PANELS.indexOf(activeId) === -1) return;

    if (!skipHash) writePanelHash(activeId);

    setPanelDisplay(activeId, skipAnimation);

    var panel = document.getElementById(activeId);

    if (!panel) return;

    /* Use Liquid-rendered products only — do not AJAX-rebuild carousel (was dropping items / breaking Slick) */
    scheduleSliderInit(panel);

  }



  function bindTabClicks() {

    var nav = document.getElementById('essentialmenu');

    if (!nav || nav.getAttribute('data-davines-bound') === '1') return;

    nav.setAttribute('data-davines-bound', '1');

    nav.addEventListener('click', function (event) {

      var link = event.target.closest('a[data-davines-panel], a[href^="#col-"]');

      if (!link || !nav.contains(link)) return;

      event.preventDefault();

      activatePanel(getPanelIdFromNavLink(link));

    });

  }



  function bindResize() {

    var timer;

    window.addEventListener('resize', function () {

      window.clearTimeout(timer);

      timer = window.setTimeout(function () {

        initCategoryNavCarousel();

        var active = getPanelsWrap() && getPanelsWrap().querySelector('.davines-line-panel.is-active');

        if (active) initSliderWithRetry(active, 0);

      }, 150);

    });

  }



  function preloadPanelProducts() {

    PANELS.forEach(function (panelId) {

      if (panelId === 'col-dede') return;

      var panel = document.getElementById(panelId);

      if (panel) ensurePanelProducts(panel);

    });

  }



  function boot() {

    bindNavSticky();

    bindTabClicks();

    bindResize();

    bindHashNavigation();

    initCategoryNavCarousel();

    var initialPanel = hashToPanelId(window.location.hash);

    var activeId = initialPanel || 'col-dede';

    whenReady(function () {

      activatePanel(activeId, true, true);

      PANELS.forEach(function (panelId) {

        if (panelId === activeId) return;

        var panel = document.getElementById(panelId);

        if (panel) scheduleSliderInit(panel);

      });

      if (initialPanel) scrollToProductLines(initialPanel);

    });

  }



  window.davinesEssential = {
    showPanel: activatePanel,
    scrollToProductLines: scrollToProductLines,
  };

  window.davinesSetEssentialPanel = activatePanel;
  window.davinesScrollToProductLines = scrollToProductLines;



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', boot);

  } else {

    boot();

  }

})();

